// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-sett-section {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}
.task-sett-section .task-sett-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.toggle-row label {
  font-weight: 500;
  color: #475569;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004A9A;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .task-sett-section {
    padding: 1rem;
  }
  .action-buttons {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/TaskSettings/TaskSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EAEA,cAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AAFF;AAIE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAHF;AAKE;EACE,gBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAJF;AAME;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAJJ;AAMI;EACE,yBAAA;AAJN;AAOI;EACE,2BAAA;AALN;AAQI;EACE,2BAAA;AANN;AAUE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AAUI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AARN;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAVF;AAYE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAVJ;AAYI;EACE,mBAAA;AAVN;AAcE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAeI;EACE,mBAAA;EACA,mBAAA;AAbN;;AAmBA;EACE;IACE,aAAA;EAhBF;EAmBA;IACE,sBAAA;EAjBF;AACF","sourcesContent":["// TaskSettings.scss - Updated to match InvoiceSettings design\r\n.task-sett-section {\r\n  padding: 2rem;\r\n  background: #f4f6f8;\r\n//   min-height: 100vh;\r\n  color: #334155;\r\n  \r\n  .task-sett-title {\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 2rem;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.settings-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.settings-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #e0e0e0;\r\n  \r\n  .card-title {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 1.2rem;\r\n    padding-bottom: 0.5rem;\r\n    border-bottom: 1px solid #f1f1f1;\r\n  }\r\n}\r\n\r\n.toggle-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  \r\n  label {\r\n    font-weight: 500;\r\n    color: #475569;\r\n  }\r\n}\r\n\r\n.toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 26px;\r\n  \r\n  input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n    \r\n    &:checked + .toggle-slider {\r\n      background-color: #004A9A;\r\n    }\r\n    \r\n    &:checked + .toggle-slider:before {\r\n      transform: translateX(24px);\r\n    }\r\n    \r\n    &:focus + .toggle-slider {\r\n      box-shadow: 0 0 1px #004A9A;\r\n    }\r\n  }\r\n  \r\n  .toggle-slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #c4c4c4;\r\n    transition: .4s;\r\n    border-radius: 34px;\r\n    \r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 22px;\r\n      width: 22px;\r\n      left: 2px;\r\n      bottom: 2px;\r\n      background-color: white;\r\n      transition: .4s;\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid #e2e8f0;\r\n  \r\n  .cancel-btn {\r\n    background: #f1f1f1;\r\n    color: #475569;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1.5rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    \r\n    &:hover {\r\n      background: #e2e8f0;\r\n    }\r\n  }\r\n  \r\n  .save-btn {\r\n    background: #004A9A;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1.5rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    \r\n    &:hover:not(:disabled) {\r\n      background: #003a7a;\r\n    }\r\n    \r\n    &:disabled {\r\n      background: #c4c4c4;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive adjustments\r\n@media (max-width: 768px) {\r\n  .task-sett-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .action-buttons {\r\n    flex-direction: column;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
